import { render, staticRenderFns } from "./StudentExchangePartnerWidget.vue?vue&type=template&id=73c22b66&"
import script from "./StudentExchangePartnerWidget.vue?vue&type=script&lang=ts&"
export * from "./StudentExchangePartnerWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports